import { Component, OnInit } from '@angular/core';

import { AppService }  from '../../services/app.service';
import { ApiConnectionService }  from '../../services/core/api-connection.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
	page : any = {};
	
	constructor(
	  	public appService: AppService,
  		public dom: DomSanitizer,
		private route: ActivatedRoute,
	  	public api: ApiConnectionService,
	  	private ngxLoader: NgxUiLoaderService
  	) { 
	  	let self = this;

		self.appService.setDefaultAuthor();
		this.appService.setShowCheckRequestAlert();
  	}

  	ngOnInit(): void {
	  	this.appService.navActive();
		
		let id = this.route.snapshot.paramMap.get('id');
		let self = this;
		
	    this.ngxLoader.start();
		this.api.read('pages/slug/'+id+'').then((response) => {
			self.page = response;
			
			self.appService.setPageTitle(''+self.page['title']+'');
			self.appService.setPageDescription(self.page['seoDescription']);
		
			self.ngxLoader.stop();
		});
  	}

	text (content) {
		return this.dom.bypassSecurityTrustHtml(content);
	}
}
